import { Order } from '../../../../Models/Order'
import OrderReviewFormCarouselItem from './OrderReviewFormCarouselItem'
import "./OrderReviewFormCarouselComponent.scss";
import { Typography, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useRef } from 'react';

interface OrderReviewFormCarouselComponentProps {
    reviewPendingOrders: Order[]
}

const OrderReviewFormCarouselComponent = ({reviewPendingOrders}: OrderReviewFormCarouselComponentProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div className='order-review-form-carousel-component-root'>
      <div className='order-review-form-carousel-header'>
        <Typography variant='h5' fontWeight={'500'} className='order-review-form-carousel-title'>Reviews Pending</Typography>
        
        <div className='order-review-form-carousel-navigation'>
          <IconButton 
            onClick={scrollLeft}
            className='navigation-arrow left-arrow'
            size="small"
          >
            <ChevronLeft />
          </IconButton>
          <IconButton 
            onClick={scrollRight}
            className='navigation-arrow right-arrow'
            size="small"
          >
            <ChevronRight />
          </IconButton>
        </div>
      </div>

      <div className='order-review-form-carousel-container' ref={scrollContainerRef}>
        {reviewPendingOrders.map((order, index) => {
            return <OrderReviewFormCarouselItem order={order} key={index}/>
        })}
      </div>
    </div>
  )
}

export default OrderReviewFormCarouselComponent